import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Installation } from 'src/app/model/installation/installation.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-connections',
  templateUrl: './installation-connections.component.html',
  styleUrls: ['./installation-connections.component.scss']
})
export class InstallationConnectionsComponent implements OnInit {

  @Input() installation : any;

  constructor(private service: InstallationsService, private router : Router, private activatedRoute : ActivatedRoute) { }
  // public installation!: Installation;

  ngOnInit(): void {

  }


  showPwd(selectedInput : string) {

    const pwdInput = <HTMLInputElement>document.getElementById(selectedInput);
    if (pwdInput !== null) {
      pwdInput.type = 'text';
      setTimeout(function () { pwdInput.type = 'password'; }, 10000);
    }

  }

  connect() {
    const machineSN = this.installation.machine.numero_serie;
    this.service.connectToApd( machineSN ).subscribe(url=>{

      window.open(url.connexionUrl, "_blank");
    });
  }

}
